import { Link } from 'react-router';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Typography } from '@mui/material';

import { theme } from '@/theme';

export default function ReportBugButton() {
  return (
    <Typography
      variant="body2"
      mt={3}
      mb={3}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
      }}
      component={Link}
      to={
        'https://crowdcode-jira.atlassian.net/jira/software/c/form/b755c1a2-259a-4d35-8b09-4e027b281ac9?atlOrigin=eyJpIjoiYmM5NzBmNWRiMzY3NDQwY2IzYjdjZGE5ZmZhZWM5MDYiLCJwIjoiaiJ9'
      }
      target="_blank"
      color={'rgba(0, 0, 0, 0.87)'}
    >
      <ReportGmailerrorredIcon sx={{ marginInlineEnd: theme.spacing(1) }}></ReportGmailerrorredIcon>
      Bug-Report senden
      <ArrowForwardIcon sx={{ marginLeft: 'auto' }}></ArrowForwardIcon>
    </Typography>
  );
}
